import {Injectable} from '@angular/core';
import {File, Entry, FileEntry} from '@awesome-cordova-plugins/file/ngx';
import {Platform} from '@ionic/angular';
import {ErrorHandlingService} from '../error-handling/error-handling.service';
import {
	APP_ASSIGN_FOLDER,
	APP_STORAGE,
	CACHE_DOWNLOAD_DIRECTORY,
	DIRECTORY_TREE
} from '../../../environments/environment';
import {MessagesService} from '../messages/messages.service';
import {FilePath} from '@awesome-cordova-plugins/file-path/ngx';
import {
	FileTransfer,
	FileTransferObject,
	FileUploadOptions,
	FileUploadResult
} from '@awesome-cordova-plugins/file-transfer/ngx';
import {FileOpener} from '@awesome-cordova-plugins/file-opener/ngx';
import {
	ConfigurationObject,
	DetailObject,
	FileHandlingAction,
	FileObj
} from '../../interfaces/interfaces.regisafe';
import {Storage} from '@ionic/storage';
import {AppConfig} from '../../app.config';
import {StorageService} from '../storage/storage.service';
import {CopyOptions} from '@capacitor/filesystem/dist/esm/definitions';
import {Directory, Filesystem} from '@capacitor/filesystem';

declare let cordova: any;

@Injectable({
	providedIn: 'root'
})
export class FileSystemService {

	public configuration: ConfigurationObject;

	/**
	 * deviceSpecificDirectoryTree()
	 * return file structure depending on platform (ios/android)
	 */
	tree: any = {
		directory: '',
		regisafeRootPath: ''
	};

	constructor(private file: File,
				private filePath: FilePath,
				private platform: Platform,
				private errorHandling: ErrorHandlingService,
				private msgService: MessagesService,
				private transfer: FileTransfer,
				private storage: Storage,
				private fileOpener: FileOpener,
				private storageService: StorageService,
				public appConfig: AppConfig) {

		this.configuration = this.appConfig.getConfig();

	}


	deviceSpecificDirectoryTree(): any {
		if (this.platform.is('ios')) {
			this.tree.directory = cordova.file.documentsDirectory;
		} else if (this.platform.is('android')) {
			this.tree.directory = cordova.file.externalDataDirectory;
			this.tree.regisafeRootPath = 'regisafeapp/';
		}
		return this.tree;
	}

	deviceSpecificCacheDirectory(): any {
		let directory: any;
		if (this.platform.is('ios')) {
			directory = cordova.file.cacheDirectory;
		} else if (this.platform.is('android')) {
			directory = cordova.file.cacheDirectory;
		}
		return directory;
	}

	/**
	 * create necessary Folders for regisafe App
	 * DIRECTORY_TREE.root
	 */
	createMainFoldersForRegisafe() {

		const tree = this.deviceSpecificDirectoryTree();

		console.log('createMainFoldersForRegisafe - tree ###', tree);

		// Ordner für regisafe erstellen
		this.file.createDir(tree.directory, DIRECTORY_TREE.root, false)
			.then((dirEntry) => {
				// erfolgreich erstellt
				if (dirEntry.isDirectory) {
					// create Folder for "add"
					this.createMainFolderForCapture();
					// create Folder for "edit"
					this.createMainFolderForEdit();
				}
			}, (e) => {
				if (e.code === 12) {
					// create Folder for "add"
					this.createMainFolderForCapture();
					// create Folder for "editn"
					this.createMainFolderForEdit();
				} else {
					// Fehler
					console.log('createMainFolderForRegisafe ERROR: ', e);
					this.errorHandling.handleFileSystemError(e);
				}
			}).catch((e) => {
			console.log('createMainFoldersForRegisafe this.file.createDir: ', e);
		});
	}

	/**
	 * create necessary SubFolders for regisafe App
	 * DIRECTORY_TREE.subfolders.add
	 */
	createMainFolderForCapture() {

		const tree = this.deviceSpecificDirectoryTree();

		// Ordner für Capture erstellen
		this.file.createDir(tree.directory, tree.regisafeRootPath + DIRECTORY_TREE.subfolders.add, false)
			.then((dirEntry) => {
				// erfolgreich erstellt
				if (dirEntry.isDirectory) {
					console.log('createMainFolderForCapture: ', dirEntry);
				}
			}, (e) => {
				// Ordner existiert bereits (e.message === PATH_EXISTS_ERR)
				if (e.code === 12) {
					// console.log('createMainFolderForCapture PATH_EXISTS_ERR: ', e);
				} else {
					// Fehler
					console.log('createMainFolderForCapture ERROR: ', e);
				}
			});
	}

	/**
	 * create necessary SubFolders for regisafe App
	 * DIRECTORY_TREE.subfolders.edit
	 */
	createMainFolderForEdit() {

		const tree = this.deviceSpecificDirectoryTree();

		// Ordner für Capture erstellen
		this.file.createDir(tree.directory, tree.regisafeRootPath + DIRECTORY_TREE.subfolders.edit, false)
			.then((dirEntry) => {
				// erfolgreich erstellt
				if (dirEntry.isDirectory) {
					console.log('createMainFolderForEdit: ', dirEntry);
				}
			}, (e) => {
				// Ordner existiert bereits (e.message === PATH_EXISTS_ERR)
				if (e.code === 12) {
					// console.log('createMainFolderForEdit PATH_EXISTS_ERR: ', e);
				} else {
					// Fehler
					console.log('createMainFolderForEdit ERROR: ', e);
				}
			});
	}

	/**
	 * Nimmt den Dateipfad von Cordova Plugin Camera entgegen,
	 * prüft ob der Ordner 'DIRECTORY_TREE.subfolders.edit' existiert
	 * und kopiert die Datei nach 'DIRECTORY_TREE.subfolders.edit'.
	 *
	 * Im Erfolgsfall wird eine Message 'filesystem:copy' an die View zurückgeben,
	 * diese enthält ebenfalls das FileEntry-Object
	 *
	 * @param filePath - Dateipfad von Cordova Plugin Camera
	 */
	storeCameraImage(filePath: any) {

		this.file.resolveLocalFilesystemUrl(filePath)
			.catch((e) => {
				console.log('storeCameraImage resolveLocalFilesystemUrl error: ', e);
			})
			.then((fileEntry: Entry) => {

				const fileUniqueId = 'regisafeapp-' + (new Date().getTime()).toString(16) + DIRECTORY_TREE.imagefileext;
				const tree = this.deviceSpecificDirectoryTree();
				const destination = DIRECTORY_TREE.subfolders.add;

				this.file.checkDir(tree.directory, tree.regisafeRootPath + destination)
					.catch((e) => {
						console.log('storeCameraImage checkDir error: ', e);
					})
					.then((dirEntry) => {

						const path = filePath.substring(0, filePath.lastIndexOf('/'));
						const filename = filePath.substring(filePath.lastIndexOf('/') + 1);

						this.file.copyFile(path, filename, tree.directory + tree.regisafeRootPath + destination, fileUniqueId)
							.catch((e) => {
								console.log('copyFile error: ', e);
							})
							.then((copiedFileEntry) => {
								this.msgService.sendMessage({context: 'filesystem:copy', entry: copiedFileEntry});
							});
					});
			});
	}

	storeChoosingFile(url: string) {
		this.filePath.resolveNativePath(url)
			.then((filePath) => {
				console.log('storeChoosingFile filePath.resolveNativePath: ', filePath);

				this.file.resolveLocalFilesystemUrl(filePath)
					.catch((e) => {
						console.log('storeChoosingFile resolveLocalFilesystemUrl error: ', e);
						this.errorHandling.handleFileSystemError(e);
					})
					.then((fileEntry) => {


						const tree = this.deviceSpecificDirectoryTree();
						const destination = DIRECTORY_TREE.subfolders.add;

						this.file.checkDir(tree.directory, tree.regisafeRootPath + destination)
							.catch((e) => {
								console.log('storeChoosingFile checkDir error: ', e);
							})
							.then((dirEntry) => {

								const path = filePath.substring(0, filePath.lastIndexOf('/'));
								const filename = filePath.substring(filePath.lastIndexOf('/') + 1);

								this.file.copyFile(path, filename, tree.directory + tree.regisafeRootPath + destination, filename)
									.catch((e) => {
										console.log('storeChoosingFile copyFile error: ', e);
										this.errorHandling.handleFileSystemError(e);
									})
									.then((copiedFileEntry) => {
										this.msgService.sendMessage({
											context: 'filesystem:copy',
											entry: copiedFileEntry
										});
									});
							});
					});

			})
			.catch((e) => {
				console.log('storeChoosingFile filePath.resolveNativePath error: ', e);
			});
	}

	storeUint8ArrayAsFile(unit8Array: Uint8Array, filename: string, type: string) {
		const tree = this.deviceSpecificDirectoryTree();
		const destination = DIRECTORY_TREE.subfolders.add;

		this.file.checkDir(tree.directory, tree.regisafeRootPath + destination)
			.catch((e) => {
				console.log('storeUint8ArrayAsFile checkDir error: ', e);
			})
			.then((dirEntry) => {

				this.file.writeFile(tree.directory + tree.regisafeRootPath + destination, filename, unit8Array)
					.catch((e) => {
						console.log('storeUint8ArrayAsFile -> writeFile -> error: ', e);
					})
					.then((fileEntry) => {
						this.msgService.sendMessage({
							context: 'filesystem:copy',
							entry: fileEntry
						});
					});
			});
	}

	getAddedFilesList() {
		const tree = this.deviceSpecificDirectoryTree();
		return this.file.listDir(tree.directory + tree.regisafeRootPath, DIRECTORY_TREE.subfolders.add);
	}

	deleteFile(fileEntry: Entry) {
		console.log('deleteFile: ', fileEntry);
		const filename = this.getFilenameFromPath(fileEntry.nativeURL);
		const pathname = this.getPathFromFullPath(fileEntry.nativeURL);
		console.log('deleteFile: ', filename, pathname);
		this.file.removeFile(pathname, filename)
			.catch((e) => {
				console.log('deleteFile removeFile error: ', e);
			})
			.then((result) => {
				console.log('removeFile: ', result);
				this.msgService.sendMessage({context: 'filesystem:delete', entry: result});
			});
	}

	deleteFiles(fileEntryList: Array<any>) {
		console.log('fileEntryList: ', fileEntryList[0]);
		const filename = this.getFilenameFromPath(fileEntryList[0].nativeURL);
		const pathname = this.getPathFromFullPath(fileEntryList[0].nativeURL);
		console.log('deleteFile: ', filename, pathname);
		this.file.removeFile(pathname, filename)
			.catch((e) => {
				console.log('deleteFile removeFile error: ', e);
			})
			.then((result) => {
				console.log('removeFile: ', result);
				fileEntryList.shift();
				if (fileEntryList.length > 0) {
					this.deleteFiles(fileEntryList);
				} else {
					this.msgService.sendMessage({context: 'filesystem:delete', entry: []});
				}
			});
	}

	/**
	 * extrahiert den Dateinamen aus einer übergebenen URL
	 *
	 * @param path - eine URL zu einer Datei
	 */
	getFilenameFromPath(path: string): string {
		return decodeURI(path.split('\\').pop().split('/').pop());
	}

	/**
	 * extrahiert den Pfad ohne Dateinamen aus einer übergebenen URL
	 *
	 * @param path - eine URL zu einer Datei
	 */
	getPathFromFullPath(path: string): string {
		return path.substring(0, path.lastIndexOf('/'));
	}

	/**
	 *  speichert eine übergebene Datei (Link) im Cache Ordner
	 *
	 * @param resp - Rückgabewert aus OrgaManagerGetFile
	 */
	downloadFileToCacheDir(resp: any) {
		const fileTransfer: FileTransferObject = this.transfer.create();
		const cacheDirectory = this.deviceSpecificCacheDirectory();

		this.file.createDir(cacheDirectory, CACHE_DOWNLOAD_DIRECTORY, true)
			.then((dirEntry) => {

				fileTransfer.download(this.configuration.iqapiDomain + resp.binary, dirEntry.nativeURL + resp.fileName, true)
					.catch((e) => {
						console.log('### downloadFileToCacheDir  error ###: ', e);
					})
					.then((fileEntry) => {
						this.openFile(fileEntry, 'view');
					})
					.finally(() => {
						// finally
					});

			})
			.catch((e) => {
				console.log('### downloadFileToCacheDir createDir  error ###: ', e);
			});

	}

	/**
	 * speichert eine übergebene Datei (Link) in einem eindeutigen Ordner (Ordnername ist die ObjectID des Schriftstückes),
	 * Der Doppelpunkt (:) in der OjectID wird dabei durch ein Minus (-) ersetzt
	 *
	 * @param resp - Rückgabewert aus OrgaManagerGetFile
	 * @param jsondBody - FileObject
	 * @param metaData - DetailObject
	 */
	downloadFileToEditDir(resp: any, jsondBody: FileObj, metaData: DetailObject) {
		const fileTransfer: FileTransferObject = this.transfer.create();
		const fileDirectory = this.deviceSpecificDirectoryTree();
		const editDirectory = fileDirectory.directory + fileDirectory.regisafeRootPath + DIRECTORY_TREE.subfolders.edit;

		this.file.createDir(editDirectory, this.convertString(jsondBody.objId, /:/g, '-'), true)
			.then((dirEntry) => {
				fileTransfer.download(this.configuration.iqapiDomain + resp.binary, dirEntry.nativeURL + resp.fileName, true)
					.catch((e) => {
						console.log('### downloadFileDoEditDir  error ###: ', e);
					})
					.then((fileEntry) => {
						this.openFile(fileEntry, 'edit');
					})
					.finally(() => {
						// finally
					});
			})
			.catch((e) => {
				console.log('### downloadFileDoEditDir createDir  error ###: ', e);
			});
	}

	/**
	 * speichert Metadaten für alle Dateien die zum barbeiten heruntergeladen wurden
	 *
	 * @param key - ObjectID des Schriftstücks
	 * @param value - Wert aus dem Feld TEXT des Schriftstückes
	 */
	setMetaDataForEditDir(key: string, value: string) {
		const newData: any = {
			objid: key,
			text: value
		};

		this.storage.get(APP_STORAGE.user.edit).then(
			(data: Array<any>) => {
				data.push(newData);
				const unique = this.getUniqueListBy(data, 'objid');
				this.storage.set(APP_STORAGE.user.edit, unique);
			});
	}

	/**
	 * entfernt Duplikate aus einem Array von Objekten anhand eines übergebenen Schlüssels
	 * Der Schlüssel ist die ObjectId des Schrifstückes
	 *
	 * @param arr - Array of Objects
	 * @param key - gesuchter Schlüssel
	 */
	getUniqueListBy(arr: Array<any>, key: string): any {
		const uniq = {};
		const arrFiltered = arr.filter(obj => !uniq[obj[key]] && (uniq[obj[key]] = true));
		return arrFiltered;
	}


	/**
	 * öffnet eine Datei als Vorschau bzw. zum bearbeiten
	 *
	 * @param entry - Dateiobject
	 * @param action - Welche Aktion soll ausgeführt werden
	 */
	openFile(entry: FileEntry, action: FileHandlingAction) {

		const fileEntry = entry as FileEntry;

		switch (action) {
			case 'view':
				fileEntry.file((file) => {
					this.fileOpener.open(entry.nativeURL, file.type);
				});
				break;

			case 'edit':
				const fileOpenercomundus = cordova.plugins.fileOpener2comundus;
				fileEntry.file((file) => {
					fileOpenercomundus.showOpenWithDialog(entry.nativeURL, file.type);
				});
				break;
		}
	}

	/**
	 * ersetzt einen gesuchten Wert in einem String durch einen anderen
	 *
	 * @param str - übergebener String
	 * @param searchvalue - was wird gesucht
	 * @param newvalue - was wird eingesetzt
	 */
	convertString(str, searchvalue, newvalue) {
		const convertedString = str.replace(searchvalue, newvalue);
		return convertedString;
	}

	async getFileMetaData(data: any) {
		console.log('### getFileMetaData - path: ', data.uri);
		this.file.resolveLocalFilesystemUrl(data.uri)
			.catch((e) => {
				console.log('### getFileMetaData - resolveLocalFilesystemUrl error: ', e);
			})
			.then((entry) => {
				console.log('### getFileMetaData - resolveLocalFilesystemUrl entry: ', entry);
				const fileEntry = entry as FileEntry;
				console.log('### getFileMetaData - resolveLocalFilesystemUrl fileEntry: ', fileEntry);

				fileEntry.file((success) => {
					console.log('### getFileMetaData - resolveLocalFilesystemUrl fileEntry.file success: ', success);

					const fileURL = success.localURL;
					const url = this.configuration.iqapiEndpoint + '/OrgaManager.HandFile';
					const transferOption: FileUploadOptions = {
						fileKey: 'binary',
						fileName: data.name,
						mimeType: success.type,
						httpMethod: 'POST',
						chunkedMode: false,
						params: {
							apiID: this.configuration.iqapiAppId,
							sessionToken: this.storageService.getToken(),
							fileName: data.name,
							dontOpenDlg: 1
						}
					};
					const fileTransfer: FileTransferObject = this.transfer.create();
					fileTransfer.upload(data.uri, url, transferOption, true)
						.catch((e) => {
							console.log('transferObj error: ', e);
						})
						.then((result: FileUploadResult) => {
							console.log('transferObj result: ', result);
						});
				});
			});

	}

	async copyFilesTo(file: string, target: string) {
		console.log('copyFilesTo: ', file);
		console.log('copyFilesTo: ', target);

		this.file.resolveLocalFilesystemUrl(file)
			.catch((e) => {
				console.log('copyFilesTo resolveLocalFilesystemUrl error: ', e);
			})
			.then((entry) => {

				console.log('copyFilesTo resolveLocalFilesystemUrl: ', entry);

				const fileEntry = entry as FileEntry;
				fileEntry.file(async (success) => {
					console.log('copyFilesTo success: ', success);

				});
			});

	}

	async kopiereDateiNach(fromPath, targetFolder, filename) {
		const options: CopyOptions = {
			from: fromPath,
			to: targetFolder + filename,
			toDirectory: Directory.Documents
		};
		return Filesystem.copy(options)
			.then((data) => true)
			.catch((error) => false);
	}
}




